import { TransactionState } from '@app/store/domain';

export type Space = {
  id: string;
  name: string;
};

export type Member = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  spaces: Space[];
  image: {
    url: string | null;
  };
};

export type PageInfo = {
  hasNextPage: boolean;
  endCursor: string | null;
};

export type PaymentPlan = {
  planName: string;
  seats: {
    total: number;
    usedTotal: number;
    additional: number;
    usedAdditional: number;
    included: number;
    usedIncluded: number;
  };
};

export type OrgDetailsWithPaymentPlan = {
  hasReachedOrganiserLimit: boolean;
  pendingMemberInvitationsCount: number;
  paymentPlan: PaymentPlan;
  features: {
    rolesAndPermissions: boolean;
  };
};

export type State = {
  ownerId: string;
  members: Member[];
  hasFetchedWithSpaces: boolean;
  memberSpacesUpdateRequestIds: Record<string, string>;
  pageInfo: PageInfo;
  paymentPlan: PaymentPlan | null;
  searchQuery: string;
  error: {
    message: string;
  };
} & TransactionState;

export const defaultState: State = {
  status: 'idle',
  ownerId: '',
  members: [],
  hasFetchedWithSpaces: false,
  memberSpacesUpdateRequestIds: {},
  pageInfo: {
    hasNextPage: false,
    endCursor: null,
  },
  paymentPlan: null,
  searchQuery: '',
  error: {
    message: '',
  },
};
